import * as Yup from "yup";
import startIcon from "../../assets/images/Start_stapper.png";
import eligibilityIcon from "../../assets/images/Eligibility_stapper.png";
import applicationIcon from "../../assets/images/Application_stepper.png";
import verifyIcon from "../../assets/images/Verify_stapper.png";
import signIcon from "../../assets/images/Signed_stepper.png";
import submitIcon from "../../assets/images/Submit_stepper.png";
import processIcon from "../../assets/images/Processing_stepper.png";
import approvedIcon from "../../assets/images/Final_descision_stepper.png";

export const formikTasks = {
    initialValues: {
      patientId: null,
      assignTo: null,
      applicationId: null,
      dueDate: null,
      title: "",
      taskAction: "",
      documentId: null,
      formId: null,
      notes: ""
    },
    validationSchema: Yup.object().shape({
      patientId: Yup.string().required("Patient is required"),
      assignTo: Yup.string().required("Assign To is required"),
      applicationId: Yup.string().required("Application is required")
    })
  };

  export const formikTasksFromActivity = {
    initialValues: {
      patientId: null,
      assignTo: null,
      applicationId: null,
      dueDate: null,
      title: "",
      taskAction: "",
      documentId: null,
      formId: null,
      notes: "",
      assignee : "Patient"
    },
    validationSchema: Yup.object().shape({
      patientId: Yup.string().required("Patient is required"),
      applicationId: Yup.string().required("Application is required"),
      taskAction: Yup.string().required("Task Action is required"),
      title: Yup.string().required("Title is required"),
      documentId: Yup.string().when("taskAction", {
        is: "Upload Document",
        then: (schema) => schema.required("Document is required"),
        otherwise: (schema) => schema.nullable().notRequired()
      }),
      formId: Yup.string().when("taskAction", {
        is: (taskAction) => ["Update Form", "Sign Form", "Verify Form"].includes(taskAction),
        then: (schema) => schema.required("Form is required"),
        otherwise: (schema) => schema.nullable().notRequired()
      })
    })
  };

export const applicationSteps = [
    { title: "Start", icon: startIcon},
    { title: "Eligibility", icon: eligibilityIcon},
    { title: "Application", icon: applicationIcon},
    { title: "Verify", icon: verifyIcon},
    { title: "Sign", icon: signIcon},
    { title: "Submit", icon: submitIcon},
    { title: "Process", icon: processIcon},
    { title: "Approved", icon: approvedIcon}
];

export const AssignToOption = [
  { label: "Patient", value: "Patient"},
  { label: "Staff", value: "Staff"}
];
